export interface FoodGroup {
  group: string,
  amount: string,
  description: string,
  recommendations: string,
}

export interface MealPlan {
  ageGroup: string,
  ageText: string,
  calories: number,
  foods: FoodGroup[],
}

const MealPlans: MealPlan[] = [
  // 4-8 1200
  {
    ageGroup: "4-8",
    ageText: "4-8 წელი",
    calories: 1200,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "4 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "2 ½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },

  // 4-8 1400
  {
    ageGroup: "4-8",
    ageText: "4-8 წელი",
    calories: 1400,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "4 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "2 ½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 4-8 1600
  {
    ageGroup: "4-8",
    ageText: "4-8 წელი",
    calories: 1600,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "2 ½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 4-8 1800
  {
    ageGroup: "4-8",
    ageText: "4-8 წელი",
    calories: 1800,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "2 ½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "1  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 4-8 2000
  {
    ageGroup: "4-8",
    ageText: "4-8 წელი",
    calories: 2000,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "2 ½  პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "1 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 1400
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 1400,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "4 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 1600
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 1600,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 1800
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 1800,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "1 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 2000
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 2000,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "1 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 2200
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 2200,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "7 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "2 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 2400
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 2400,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "8 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "6 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "2 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 2600
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 2600,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "9 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "6 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 2800
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 2800,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "10 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "7 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 3000
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 3000,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "12 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "7 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 9-13 3200
  {
    ageGroup: "9-13",
    ageText: "9-13 წელი",
    calories: 3200,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "13 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "8 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 1600
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 1600,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 1800
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 1800,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "1 ½ პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "1 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 2000
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 2000,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "5 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "1 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 2200
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 2200,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "7 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "6 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "2 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 2400
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 2400,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "8 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "6 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "2 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 2600
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 2600,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "9 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "6 ½ პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 2800
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 2800,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "10 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "7 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 3000
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 3000,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "12 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "7 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion

  // 14-99 3200
  {
    ageGroup: "14-99",
    ageText: "14+ წელი",
    calories: 3200,
    foods: [
      {
        group: "ხილი/ჩირეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი ცოცხალი, დაკონსერვებული ან გაყინული ხილი\n40 გრამი ჩირეული\n30 გრამი ფინიკი",
        recommendations: ""
      },
      {
        group: "ბოსტნეული",
        amount: "2 პორცია",
        description:
        "1 პორცია ითვლება როგორც:\n200 გრამი უმი/მოხარშული/გრილზე მომზადებული/მოთუშული ბოსტნეული",
        recommendations: "აარჩიეთ რაც შეიძლება მეტი ფერის ბოსტნეული,\nმაგ.: წითელი, სტაფილოსფერი/ყვითელი, მწვანე, თეთრი/ყავისფერი, იასამნისფერი"
      },
      {
        group: "ნახშირწყლები (მარცვლეული და სახამებელი)",
        amount: "13 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n1 ნაჭერი პური (40 გრამი)\n30 გრამი უმი წონა ან 100 გრამი მზა მარცვლეული (შვრიის მარცვალი, ბულგური, ყავისფერი ბრინჯი, ქინოა, ბარდა, წიწიბურა)\n30 გრამი უმი წონა ან 70 გრამი მოხარშული მთელმარცვლოვანი მაკარონი\n60 გრამი მჭადი ან 120 გრამი ღომი\n100 გრამი კარტოფილის პიურე ან 120 გრამი მოხარშული/გამომცხვარი კარტოფილი კანიანად",
        recommendations: ""
      },
      {
        group: "ცილოვანი საკვები",
        amount: "8 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n80 გრამი უმი წონა/60 გრამი მოხარშული/გრილზე შემწვარი ფრინველის თეთრი ხორცი კანის გარეშე ან საქონლის ხორცის ნაკლებცხიმიანი ნაჭერი\n50 გრამი უმი წონა/40 გრამი მზა წონა ორაგული ან 90 გრამი წყალში მოთავსებული თინუსის კონსერვი ან 70 გრამი უმი წონა/50 გრამი მზა წონა კალმახი\n1 დიდი კვერცხი ან 2 პატარა კვერცხი\n30 გრამი უმი წონა/70 გრამი მზა წონა სოიო, ლობიო, ოსპი ან მუხუდო",
        recommendations: ""
      },
      {
        group: "რძის პროდუქტები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n200 გრამი 1.5%-იანი რძე ან 3.2%-იანი მაწონი ლაქტოზიანიც და ულაქტოზოც\n200 გრამი სოიოს რძე\n150 გრამი 3.5%-იანი კეფირი\n100 გრამი 4%-იანი ხაჭო ან 70 გრამი ნადუღი\n40 გრამი ყველი",
        recommendations: ""
      },
      {
        group: "ჯანსაღი ცხიმები",
        amount: "3 პორცია",
        description:
          "1 პორცია ითვლება როგორც:\n12 გრამი ზეთი (1 არასრული ს.კ)\n15 გრამი თხილეული ან თესლეული (მაგ.: ნიგოზი, ნუში, გოგრის თესლი, ჩია და სელი)\n1 ს.კ. მიწისთხილის კარაქი (16 გრამი)\n60 გრამი ავოკადო\n75 გრამი ზეთისხილი",
        recommendations: ""
      },
    ],
  },
  //#endregion
];

export default MealPlans;